// app/javascript/controllers/dual_range_slider_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["min", "max", "minInput", "maxInput", "track", "hiddenMinInput", "hiddenMaxInput"]
    static values = {
        min: Number,
        max: Number,
        step: { type: Number, default: 1 }
    }

    connect() {
        // Initialize from input values if present, otherwise use data attributes
        const initialMin = parseInt(this.minInputTarget.value) || this.minValue
        const initialMax = parseInt(this.maxInputTarget.value) || this.maxValue

        this.minInputTarget.value = initialMin
        this.maxInputTarget.value = initialMax
        this.minTarget.value = initialMin
        this.maxTarget.value = initialMax
        this.minTarget.min = this.minValue
        this.minTarget.max = this.maxValue
        this.maxTarget.min = this.minValue
        this.maxTarget.max = this.maxValue
        this.updateHiddenInput()
        this.updateTrack()
    }

    minSliderChanged() {
        const minVal = parseInt(this.minTarget.value)
        const maxVal = parseInt(this.maxInputTarget.value) || this.maxValue

        if (minVal > maxVal) {
            this.minTarget.value = maxVal
            this.minInputTarget.value = maxVal
        } else {
            this.minInputTarget.value = minVal
        }

        this.updateHiddenInput()
        this.updateTrack()
        this.dispatchChange()
        this.submitForm()
    }

    maxSliderChanged() {
        const minVal = parseInt(this.minInputTarget.value) || this.minValue
        const maxVal = parseInt(this.maxTarget.value)

        if (maxVal < minVal) {
            this.maxTarget.value = minVal
            this.maxInputTarget.value = minVal
        } else {
            this.maxInputTarget.value = maxVal
        }

        this.updateHiddenInput()
        this.updateTrack()
        this.dispatchChange()
        this.submitForm()
    }

    minValueChanged() {
        const minVal = parseInt(this.minInputTarget.value) || this.minValue
        const maxVal = parseInt(this.maxInputTarget.value) || this.maxValue

        if (minVal > maxVal) {
            this.minInputTarget.value = maxVal
            this.minTarget.value = maxVal
        } else {
            this.minTarget.value = minVal
        }

        this.updateHiddenInput()
        this.updateTrack()
        this.dispatchChange()
        this.submitForm()
    }

    maxValueChanged() {
        const minVal = parseInt(this.minInputTarget.value) || this.minValue
        const maxVal = parseInt(this.maxInputTarget.value) || this.maxValue

        if (maxVal < minVal) {
            this.maxInputTarget.value = minVal
            this.maxTarget.value = minVal
        } else {
            this.maxTarget.value = maxVal
        }

        this.updateHiddenInput()
        this.updateTrack()
        this.dispatchChange()
        this.submitForm()
    }

    updateTrack() {
        const min = parseInt(this.minInputTarget.value) || this.minValue
        const max = parseInt(this.maxInputTarget.value) || this.maxValue
        const totalMin = this.minValue
        const totalMax = this.maxValue

        const minPercent = ((min - totalMin) / (totalMax - totalMin)) * 100
        const maxPercent = ((max - totalMin) / (totalMax - totalMin)) * 100

        this.trackTarget.style.background = `
      linear-gradient(to right,
        #d1d5db 0%,
        #d1d5db ${minPercent}%,
        #3b82f6 ${minPercent}%,
        #3b82f6 ${maxPercent}%,
        #d1d5db ${maxPercent}%,
        #d1d5db 100%)
    `
    }

    dispatchChange() {
        this.dispatch("change", {
            detail: {
                min: parseInt(this.minInputTarget.value) || this.minValue,
                max: parseInt(this.maxInputTarget.value) || this.maxValue
            }
        })
    }

    updateHiddenInput() {
        const min = parseInt(this.minInputTarget.value) || this.minValue
        const max = parseInt(this.maxInputTarget.value) || this.maxValue
        this.hiddenMinInputTarget.value = min
        this.hiddenMaxInputTarget.value = max
    }

    submitForm() {
        const form = this.element.closest("form")
        if (form) {
            // Use setTimeout to ensure the form data is updated before submission
            setTimeout(() => {
                form.requestSubmit()
            }, 100)
        }
    }
}